module.exports = __webpack_public_path__ + "static/media/apercu-light.a54d605d.woff2";